/** Item surfaces own printable keys, except the global palette shortcut. */
export function typeaheadKey(e: { key: string; metaKey: boolean; ctrlKey: boolean; altKey: boolean }) {
  return e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey && e.key !== " " && e.key !== "/";
}

export function typeaheadMatch(
  state: { text: string; at: number },
  key: string,
  labels: string[][],
  now = Date.now(),
): number {
  state.text = now - state.at > 700 ? key.toLowerCase() : state.text + key.toLowerCase();
  state.at = now;
  const byName = labels.findIndex((names) => names[0]?.toLowerCase().startsWith(state.text));
  return byName >= 0
    ? byName
    : labels.findIndex((names) => names.slice(1).some((name) => name.toLowerCase().startsWith(state.text)));
}
